import React, { useState } from 'react'
import BannerTab from './Tabs/BannerTab'
import InstaTab from './Tabs/InstagramTab'

const BannerManagement = () => {
    const [activeTab, setActiveTab] = useState('header')

    const handleTabClick = (tabIndex) => {
        setActiveTab(tabIndex)
    }

  return (
    <div className="tabbing-wrapper">
                <div className="admin-card tab-menu" id="nav-tab">
                    <ul>
                        <li className="tab-link">
                        </li>
                        <li className="tab-link">
                            <a
                                className={
                                    activeTab === 'header' ? 'active' : ''
                                }
                                onClick={() => handleTabClick('header')}
                            >
                                Header
                            </a>
                        </li>
                        <li className="tab-link">
                            <a
                                className={
                                    activeTab === 'insta' ? 'active' : ''
                                }
                                onClick={() => handleTabClick('insta')}
                            >
                                Instagram
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="tab-content p-0" id="nav-tabContent">
               
                    <div
                        id="header"
                        className={`tab-pane ${
                            activeTab === 'header' ? 'active' : ''
                        }`}
                    >
                        <BannerTab />
                    </div>
                    <div
                        id="insta"
                        className={`tab-pane ${
                            activeTab === 'insta' ? 'active' : ''
                        }`}
                    >
                       <InstaTab />
                    </div>
                </div>
            </div>
  )
}

export default BannerManagement